import React, { SetStateAction } from "react";
import Chevron from "assets/Icon_Btn_07.png";
import { GatewayExpandControlProps } from "../GatewaySummary.types";
import { getChevronClasses } from "../GatewaySummary.utils";
import { HeaderMilestoneNA } from "./HeaderMilestoneNA";

/**
 * GatewayExpandControl component renders the expand/collapse button and NA checkbox
 * Handles visual state of chevron and gateway NA functionality
 */
export const GatewayExpandControl: React.FC<GatewayExpandControlProps> = ({
  gateway,
  expand,
  onExpand,
  setExpand,
  onPrint,
  projectID,
  gatewayIndex,
  gatewayData,
  setGatewayData,
  backgroundReloadGatewayDataToggle,
  setBackgroundReloadGatewayDataToggle,
  onNAChange,
}) => {
  return (
    <div className="PrintContainer" style={{ display: "flex", flexDirection: "row" }}>
      {/* NA Checkbox */}
      {gateway.bGatewayNAEnabled &&
        typeof gatewayIndex === "number" &&
        gatewayData &&
        setGatewayData &&
        typeof backgroundReloadGatewayDataToggle === "boolean" &&
        setBackgroundReloadGatewayDataToggle && (
          <HeaderMilestoneNA
            gateway={gateway}
            projectID={projectID}
            gatewaysID={gateway.gatewaysID}
            gatewayTemplateID={gateway.gatewayTemplateID}
            gatewayIndex={gatewayIndex}
            gatewayData={gatewayData}
            setGatewayData={setGatewayData}
            backgroundReloadGatewayDataToggle={backgroundReloadGatewayDataToggle}
            setBackgroundReloadGatewayDataToggle={setBackgroundReloadGatewayDataToggle}
            setExpand={setExpand}
          />
        )}

      {/* Expand Gateway button */}
      <img className={getChevronClasses(expand, gateway)} src={Chevron} />
    </div>
  );
};
